import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "description": {
      "column": {
        "default": null,
        "name": "description",
        "null": true,
        "type": "text"
      },
      "name": "description",
      "selected_by_default": null,
      "translated": null
    },
    "display_name": {
      "column": {
        "default": null,
        "name": "display_name",
        "null": true,
        "type": "string"
      },
      "name": "display_name",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "StripeTaxRate",
  "collectionKey": "stripe_tax_rates",
  "collectionName": "stripe_tax_rates",
  "i18nKey": "stripe_tax_rate",
  "camelizedLower": "stripeTaxRate",
  "name": "StripeTaxRate",
  "nameDasherized": "stripe-tax-rate",
  "pluralName": "stripe_tax_rates",
  "ransackable_associations": [
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "auditable_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "Country",
      "collectionName": "countries",
      "foreignKey": "stripe_tax_rate_id",
      "name": "countries",
      "macro": "has_many",
      "resource_name": "Country",
      "through": null
    },
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "auditable_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "StripeSubscriptionDefaultTaxRate",
      "collectionName": null,
      "foreignKey": "stripe_tax_rate_id",
      "name": "stripe_subscription_default_tax_rates",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "active",
      "column": {
        "default": null,
        "name": "active",
        "null": true,
        "type": "boolean"
      }
    },
    {
      "name": "country",
      "column": {
        "default": null,
        "name": "country",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "created",
      "column": {
        "default": null,
        "name": "created",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "description",
      "column": {
        "default": null,
        "name": "description",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "display_name",
      "column": {
        "default": null,
        "name": "display_name",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "inclusive",
      "column": {
        "default": null,
        "name": "inclusive",
        "null": true,
        "type": "boolean"
      }
    },
    {
      "name": "jurisdiction",
      "column": {
        "default": null,
        "name": "jurisdiction",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "percentage",
      "column": {
        "default": null,
        "name": "percentage",
        "null": true,
        "type": "float"
      }
    },
    {
      "name": "stripe_id",
      "column": {
        "default": null,
        "name": "stripe_id",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "tax_type",
      "column": {
        "default": null,
        "name": "tax_type",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [],
  "paramKey": "stripe_tax_rate",
  "primaryKey": "id"
}

/** Frontend model for StripeTaxRate. */
class StripeTaxRate extends BaseModel {
  /** @returns {Record<string, any>} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  description() {
    return this.readAttributeUnderscore("description")
  }

  /** @returns {boolean} */
  hasDescription() {
    const value = this.description()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  displayName() {
    return this.readAttributeUnderscore("display_name")
  }

  /** @returns {boolean} */
  hasDisplayName() {
    const value = this.displayName()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {string} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }
}

export default StripeTaxRate
